/* External */
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

/* Storage */
import { selectAllChannels } from '../storage/channels';

/* Hooks */
import useFetchCarousel from './useFetchCarousel';
import useIsFetchingChannels from './useIsFetchingChannels';
import useCarouselContents from './useCarouselContents';
import useFilterChannelsForYou from './useFilterChannelsForYou';

/* Utils */
import { EPG_FILTERS_TYPES, RECENTLY_WATCHED_PARAMS } from '../utils/constants';

export default function useFilterChannels(filter) {
  const { carousel, isFetching: isFetchingCarousel } = useFetchCarousel({
    sourceCarouselId: filter?.type === EPG_FILTERS_TYPES.SECTION ? filter?.id : '',
    type: filter?.id === RECENTLY_WATCHED_PARAMS.sourceCarouselId ? RECENTLY_WATCHED_PARAMS.type : '',
    source: filter?.id === RECENTLY_WATCHED_PARAMS.sourceCarouselId ? RECENTLY_WATCHED_PARAMS.source : '',
  });
  const sectionChannels = useCarouselContents(carousel);

  const {
    channels: forYouChannels,
    isFetching: isFetchingForYou,
  } = useFilterChannelsForYou(filter?.type === EPG_FILTERS_TYPES.FOR_YOU);

  const allChannels = useSelector(selectAllChannels);

  const channelsByCategory = useMemo(() => allChannels
    .filter((channel) => channel.categories?.includes(filter?.name)), [allChannels, filter]);

  const isFetchingChannels = useIsFetchingChannels();

  switch (filter?.type) {
    case EPG_FILTERS_TYPES.ALL: {
      return {
        channels: allChannels,
        isFetching: isFetchingChannels,
      };
    }
    case EPG_FILTERS_TYPES.CATEGORY: {
      return {
        channels: channelsByCategory,
        isFetching: isFetchingChannels,
      };
    }
    case EPG_FILTERS_TYPES.SECTION: {
      return {
        channels: sectionChannels,
        isFetching: isFetchingCarousel,
      };
    }
    case EPG_FILTERS_TYPES.FOR_YOU: {
      return {
        channels: forYouChannels,
        isFetching: isFetchingForYou,
      };
    }
    default: {
      return { isFetching: true };
    }
  }
}
